// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".primary-cta[data-v-39e548eb]{background-color:#ededed;margin:0 calc(-25vw + 25%) 2rem;max-width:calc(100% + 100px);padding:1.5rem calc(25vw - 25%)}@media(min-width:992px){.primary-cta[data-v-39e548eb]{margin:0 -50px 2rem;padding:1.5rem 50px}}.xxl-page .primary-cta[data-v-39e548eb]{margin:0 0 2rem}@media(min-width:992px){.xxl-page .primary-cta[data-v-39e548eb]{max-width:1032px;width:50%}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
